export const json = {
  completedHtml: 'Благодарим за сотрудничество!',
  pages: [
    {
      elements: [
        {
          choices: [
            'конкурс существенно влияет на повышение престижа профессии учителя',
            'конкурс влияет на повышение престижа учителей-участников конкурса',
            'конкурс не влияет на повышение престижа профессии учителя',
          ],
          name: '1_element',
          showNumber: true,
          title:
            'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» влияет на повышение престижа профессии учителя?',
          type: 'checkbox',
        },
        {
          choices: [
            {
              value: 'true',
              text: 'да',
            },
            {
              value: 'false',
              text: 'нет',
            },
          ],
          name: '2_element',
          title: 'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» можно рассматривать как механизм популяризации профессии учителя?',
          type: 'radiogroup',
        },
        {
          choices: [
            {
              value: 'true',
              text: 'да',
            },
            {
              value: 'false',
              text: 'нет',
            },
          ],
          name: '3_element',
          title: 'Считаете ли Вы, что Всероссийский конкурс «Учитель года России» можно рассматривать как механизм выявления и распространения лучших педагогических практик?',
          type: 'radiogroup',
        },
        {
          name: '4_element',
          title: 'Поделитесь своими наблюдениями, насколько федеральные профессиональные конкурсы влияют/не влияют на развитие региональных систем образования:',
          type: 'comment',
        },
        {
          choices: [
            'отличий нет, региональные этапы проводятся в формате заключительного этапа Конкурса',
            'имеется незначительное отличие',
            'имеются существенные различия',
          ],
          name: '5_element',
          showNumber: true,
          title:
            'Сравните формат и содержание конкурсных испытаний на региональном и федеральном уровнях. Отметьте выбранный ответ: ',
          type: 'checkbox',
        },
        {
          elements: [
            {
              choices: [
                'должны быть идентичными',
                'должны быть частично схожими',
                'не должны быть идентичными',
              ],
              name: '6_1',
              hideNumber: true,
              title:
                ' ',
              type: 'checkbox',
            },
            {
              hideNumber: true,
              name: '6_2',
              title: 'Прокомментируйте свой ответ:',
              type: 'comment',
            },
          ],
          name: '6_element',
          showNumber: true,
          hasOther: true,
          title:
            'Как Вы полагаете, формат и содержание конкурсных испытаний на региональном и федеральном уровнях должны быть идентичными?',
          type: 'panel',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '7_1',
              title: 'оптимально:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '7_2',
              title:
                'соответствует специфике деятельности учителя:',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '7_3',
              title: 'позволяет объективнее оценить выступления конкурсантов:',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '7_4',
              title: 'иное:',
              type: 'comment',
            },
          ],
          name: '7_element',
          showNumber: true,
          hasOther: true,
          title:
            'На Ваш взгляд, формирование жюри 1 очного тура Конкурса на межпредметной основе',
          type: 'panel',
        },
        {
          choices: [
            {
              value: 'yes',
              text: 'да',
            },
            {
              value: 'no',
              text: 'нет',
            },
          ],
          name: '8_element',
          title: 'Считаете ли Вы целесообразным включение в жюри второго и третьего туров Конкурса ученического и родительского жюри?',
          type: 'radiogroup',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '9_1',
              title: ' ',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '9_2',
              title:
                'Прокомментируйте свой ответ:',
              type: 'comment',
            },
          ],
          name: '9_element',
          showNumber: true,
          title:
            'Считаете ли Вы целесообразной структуру финала Всероссийского конкурса «Учитель года России» 2020 года?',
          type: 'panel',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'yes',
                  text: 'да',
                },
                {
                  value: 'no',
                  text: 'нет',
                },
              ],
              hideNumber: true,
              name: '10_1',
              title: ' ',
              type: 'radiogroup',
            },
            {
              hideNumber: true,
              name: '10_2',
              title:
                'Прокомментируйте свой ответ:',
              type: 'comment',
            },
          ],
          name: '10_element',
          showNumber: true,
          showQuestionNumbers: 'off',
          title:
            'Считаете ли Вы целесообразным включение в третий тур финала Конкурса конкурсного испытания «Пресс-конференция «Вопрос учителю года»?',
          type: 'panel',
        },
        {
          elements: [
            {
              hideNumber: true,
              name: '11_1',
              title: ' ',
              type: 'text',
            },
            {
              hideNumber: true,
              name: '11_2',
              title:
                'Прокомментируйте свой ответ:',
              type: 'comment',
            },
          ],
          name: '11_element',
          showNumber: true,
          title:
            'Назовите конкурсное испытание, при участии в котором, на Ваш взгляд, конкурсанты испытывали наибольшие затруднения.',
          type: 'panel',
        },
        {
          name: '12_element',
          showNumber: true,
          title:
            'Укажите, что из составляющих заключительного этапа Конкурса-2020, по Вашему мнению, было бы полезно апробировать на региональном уровне:',
          type: 'comment',
        },
        {
          name: '13_element',
          showNumber: true,
          title:
            'Ваши предложения по совершенствованию финала Всероссийского конкурса «Учитель года России»:',
          type: 'comment',
        },
        {
          elements: [
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '14_1',
              title: 'организация конкурсных испытаний',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '14_2',
              title: 'трансляция конкурсных испытаний',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '14_3',
              title: 'мероприятия по программе',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '14_4',
              title: 'информационное сопровождение',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '14_5',
              title: 'трансфер',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '14_6',
              title: 'проживание',
              type: 'radiogroup',
            },
            {
              choices: [
                {
                  value: 'high',
                  text: 'высокий',
                },
                {
                  value: 'medium',
                  text: 'средний',
                },
                {
                  value: 'low',
                  text: 'низкий',
                },
              ],
              hideNumber: true,
              name: '14_7',
              title: 'питание',
              type: 'radiogroup',
            },
          ],
          name: '14_element',
          showNumber: true,
          hasOther: true,
          title:
            'Оцените уровень организации Вашего пребывания на заключительном этапе Всероссийского конкурса «Учитель года России» 2020 года',
          type: 'panel',
        },
      ],
      name: 'page1',
      showNumber: false,
      showQuestionNumbers: 'true',
      title:
        'Уважаемый коллега! Просим заполнить анкету, которая позволит учесть Ваше мнение при организации финала Всероссийского конкурса «Учитель года России» в 2021 году.',
    },
  ],
  showCompletedPage: true,
  title: 'АНКЕТА СОПРОВОЖДАЮЩЕГО, осуществляющего организационно-методическое сопровождение участников финала Всероссийского конкурса «Учитель года России» 2020 года',
};
